import { projectQuery } from '@/features/projects/queries/projects-query'
import { WorkOrdersListPage } from '@/features/work-orders/pages/work-orders-list-page'
import { workOrdersListQuery } from '@/features/work-orders/queries/work-orders-list-query'
import { messages } from '@/lib/i18n/messages'
import { createFileRoute } from '@tanstack/react-router'
import * as z from 'zod'

const PAGE_SIZE = 50

const woListSearchSchema = z.object({
  status: z.enum(['draft', 'posted']).optional(),
  page: z.coerce.number().int().positive().catch(1),
})

export const Route = createFileRoute('/projects/$projectId/_layout/work-orders/')({
  validateSearch: woListSearchSchema,
  loaderDeps: ({ search }) => ({
    status: search.status,
    page: search.page,
  }),
  loader: ({ params, deps, context }) =>
    Promise.all([
      context.queryClient.ensureQueryData(
        workOrdersListQuery({
          project_id: params.projectId,
          status: deps.status,
          limit: PAGE_SIZE,
          offset: (deps.page - 1) * PAGE_SIZE,
        }),
      ),
      context.queryClient.ensureQueryData(projectQuery(params.projectId)),
    ]),
  staticData: { crumb: messages.crumbs.workOrders },
  component: WorkOrdersListPage,
})
